<template>
  <div id="managerhome" class="managerhome">
    <HomeHeader />
    <div class="mid">
      <div class="mid-one w12">
        <div class="up">
          <div class="up-left" v-loading="messageLoading">
            <el-carousel
              trigger="click"
              height="356px"
              :interval="5000"
              arrow="always"
              style="width:730px; margin:0px auto; overflow-y:hidden"
            >
              <el-carousel-item v-for="item in fairList" :key="item.ruid" height="305px">
                <div v-if="item.type == 'fairindex'">
                  <div class="oneimg" @click="clickMore(item.type, item.ruid)">
                    <img
                      :src="preview(item.cover)"
                      style="width:730px;height:300px; cursor: pointer;"
                    />
                  </div>
                  <div
                    class="nickname"
                    stlyle="background-color:white;"
                    @click="clickMore(item.type, item.ruid)"
                  >
                    <p class="bookfair-name textover">{{ item.name }}</p>
                    <!-- <p class="pagetext"><span class="bookfair-index bookfair-index-current">{{index+1}}</span><span class="bookfair-index">/{{fairList.length}}</span></p> -->
                  </div>
                </div>
                <div v-if="item.type == 'informationindex'">
                  <div class="oneimg" @click="clickMore(item.type, item.ruid)">
                    <img :src="preview(item.cover)" style="width:730px;height:300px;" />
                  </div>
                  <div
                    class="nickname"
                    stlyle="background-color:white;"
                    @click="clickMore(item.type, item.ruid)"
                  >
                    <p class="bookfair-name textover">{{ item.title }}</p>
                    <!-- <p class="pagetext"><span class="bookfair-index bookfair-index-current">{{index+1}}</span><span class="bookfair-index">/{{fairList.length}}</span></p> -->
                  </div>
                </div>
                <div v-if="item.type == 'thematiclibindex'">
                  <div class="oneimg" @click="clickMore(item.type, item.ruid)">
                    <img
                      :src="preview(item.homebanner)"
                      style="width:730px;height:300px;"
                    />
                  </div>
                  <div
                    class="nickname"
                    stlyle="background-color:white;"
                    @click="clickMore(item.type, item.ruid)"
                  >
                    <p class="bookfair-name textover">{{ item.name }}</p>
                    <!-- <p class="pagetext"><span class="bookfair-index bookfair-index-current">{{index+1}}</span><span class="bookfair-index">/{{fairList.length}}</span></p> -->
                  </div>
                </div>
              </el-carousel-item>
            </el-carousel>
          </div>
          <div class="up-right" v-loading="messageLoading">
            <div class="notic-title-img">
              <img src="../../assets/images/notic.png" class="notic" />
            </div>
            <div
              class="notic-info"
              v-for="item in messageList"
              :key="item.ruid"
              @click="clickMore('notice', item.ruid)"
            >
              <div class="notic-title line2" :title="item.title">{{ item.title }}</div>
              <div class="notic-time">{{ item.updateTime }}</div>
            </div>
            <div class="nodata" v-if="messagetotal < 1">
              <img src="../../assets/images/ibnoData.png" alt="" />
              <p>暂无消息!</p>
            </div>
          </div>
        </div>
      </div>

      <div class="mid-two w12">
        <div class="resource-img-div stitle-img-div">
          <img src="../../assets/images/resource.png" class="resource-img stitle-img" />
          <span class="resource-more stitle-more" @click="clickMore('resource')">
            更多
          </span>
        </div>
        <div class="resource-body" v-loading="booksLoading">
          <div class="resource-type">
            <span
              id="paper"
              class="resource-type-span resource-type-span-blue"
              @click="chagebook(1)"
            >
              <img
                :src="paperimg ? blueImg : grayImg"
                id="paperimg"
                class="resourceimg"
              />
              纸书
            </span>
            <!-- <span id="paperebook" class="resource-type-span resource-type-span-gray" @click="chagebook(2)"><img :src=" paperebookimg ? blueImg : grayImg" id="paperebookimg" class="resourceimg"/> 纸+电</span> -->
            <span
              id="ebook"
              class="resource-type-span resource-type-span-gray"
              @click="chagebook(3)"
            >
              <img
                :src="ebookimg ? blueImg : grayImg"
                id="ebookimg"
                class="resourceimg"
              />
              电子书
            </span>
          </div>
          <div id="paperList">
            <div
              class="resource-object"
              v-for="(item, index) in paperList"
              :key="item.ruid"
              v-show="index < 5"
              @click="clickMore('paperList', item.ruid)"
            >
              <div class="img">
                <img :src="preview(item.cover)" class="resource-object-img" />
              </div>
              <div class="resource-title line2" :title="item.title">{{ item.title }}</div>
              <div class="resource-titlecn line2" :title="item.titleCn">
                {{ item.titleCn }}
              </div>
            </div>
            <div class="nodata" v-if="papertotal == 0">
              <img src="../../assets/images/ibnoData.png" alt="" />
              <p>暂无内容</p>
            </div>
          </div>
          <div id="paperEbookList" class="resource-object-hide">
            <div
              class="resource-object"
              v-for="(item, index) in paperEbookList"
              :key="item.ruid"
              v-show="index < 5"
              @click="clickMore('paperEbookList', item.ruid)"
            >
              <div class="img">
                <img :src="preview(item.cover)" class="resource-object-img" />
              </div>
              <div class="resource-title line2" :title="item.title">{{ item.title }}</div>
              <div class="resource-titlecn line2" :title="item.titleCn">
                {{ item.titleCn }}
              </div>
            </div>
            <div class="nodata" v-if="paperEbooktotal == 0">
              <img src="../../assets/images/ibnoData.png" alt="" />
              <p>暂无内容</p>
            </div>
          </div>
          <div id="ebookList" class="resource-object-hide">
            <div
              class="resource-object"
              v-for="(item, index) in ebookList"
              :key="item.ruid"
              v-show="index < 5"
              @click="clickMore('ebookList', item.ruid)"
            >
              <div class="img">
                <img :src="preview(item.cover)" class="resource-object-img" />
              </div>
              <div class="resource-title line2" :title="item.title">{{ item.title }}</div>
              <div class="resource-titlecn line2" :title="item.titleCn">
                {{ item.titleCn }}
              </div>
            </div>
            <div class="nodata" v-if="ebooktotal == 0">
              <img src="../../assets/images/ibnoData.png" alt="" />
              <p>暂无内容</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mid-three" v-loading="booksLoading">
      <div class="w12">
        <div class="database-title-img  stitle-img-div">
          <img src="../../assets/images/database-title.png" class="stitle-img" />
          <span class="database-more stitle-more" @click="clickMore('database')">
            更多
          </span>
        </div>
        <div class="database-list">
          <div
            class="database-object"
            v-for="(item, index) in seniorEbookCollectionList"
            :key="item.ruid"
            v-show="index < 2"
          >
            <div
              class="database-logo-div"
              @click="clickMore('databasedetail', item.ruid)"
            >
              <img :src="preview(item.cover)" class="database-logo" />
            </div>
            <div class="database-info">
              <div
                class="database-title textover"
                :title="item.title"
                @click="clickMore('databasedetail', item.ruid)"
              >
                {{ item.title }}
              </div>
              <div class="database-intro textover">{{ item.titleCn }}</div>
              <div class="database-intro textover" v-if="item.publisher">
                出版社：{{ item.publisher }}
              </div>
              <div class="database-intro textover" v-if="item.bookCount">
                资源量：{{ item.bookCount }}
              </div>
              <!-- <div class="database-intro textover" v-if="item.packageCount">学科包：{{item.packageCount}}</div> -->
              <div class="database-intro textover" v-if="item.unitCount">
                订购单元：{{ item.unitCount }}
              </div>
            </div>
          </div>
          <div class="nodata" v-if="seniorEbookCollectiontotal == 0">
            <img src="../../assets/images/ibnoData.png" alt="" />
            <p>暂无内容</p>
          </div>
        </div>
      </div>
    </div>
    <div class="mid-four w12" v-loading="knowledgeLoading">
      <div class="knowledge-bar stitle-img-div">
        <img
          src="../../assets/images/knowledge.png"
          class="knowledge-bar-img stitle-img"
        />
        <span class="resource-more stitle-more" @click="clickMore('knowledge')">
          更多
        </span>
      </div>
      <div class="keypoint-list">
        <div class="keypoint keypoint-border-bottom" @click="handleChangeTab(1)">
          <p><img src="../../assets/images/knowledge-author.png" /></p>
          <div
            class="knowledge-keypoint-word knowledge-keypoint-word-click"
            id="keyauthor"
          >
            重点作者
          </div>
        </div>
        <div class="keypoint" @click="handleChangeTab(2)">
          <p><img src="../../assets/images/knowledge-awards.png" /></p>
          <div class="knowledge-keypoint-word" id="keyaward">重点奖项</div>
        </div>
        <div class="keypoint" @click="handleChangeTab(3)">
          <p><img src="../../assets/images/knowledge-libray.png" /></p>
          <div class="knowledge-keypoint-word" id="keylibrary">重点图书馆</div>
        </div>
        <div class="keypoint" @click="handleChangeTab(4)">
          <p><img src="../../assets/images/knowledge-publisher.png" /></p>
          <div class="knowledge-keypoint-word" id="keypublisher">重点出版社</div>
        </div>
      </div>
      <div class="swipertab">
        <div class="swiper-container swiper-container_index">
          <div class="swiper-wrapper">
            <div class="swiper-slide">
              <div
                class="swiperlist"
                v-for="(item, index) in seniorAuthorList"
                :key="item.ruid"
                v-show="index < 2"
              >
                <div
                  class="swiperlist-left"
                  @click="clickMore('knowledgeauthor', item.ruid)"
                >
                  <p><img :src="preview(item.cover)" class="swiperlist-img" /></p>
                </div>
                <div class="swiperlist-right">
                  <div
                    class="award-title swiperlist-name textover"
                    :title="item.title"
                    @click="clickMore('knowledgeauthor', item.ruid)"
                  >
                    {{ item.title }}
                  </div>
                  <div class="award-titlecn textover" v-if="item.titleCn">
                    {{ item.titleCn }}
                  </div>
                  <div class="swiperlist-intro textover" v-if="item.country2">
                    <span class="littletitle">国别：</span>
                    {{ item.country2 }}
                  </div>
                  <!-- <div class="swiperlist-intro textover" v-if="item.birthstr"><span class="littletitle">生卒年：</span>{{item.birthstr}}</div> -->
                  <div class="swiperlist-intro textover" v-if="item.birth || item.death">
                    <span class="littletitle">生卒年：</span>
                    <span>{{ item.birth }} - {{ item.death }}</span>
                  </div>
                  <div class="swiperlist-intro textover" v-if="item.academicfield">
                    <span class="littletitle">研究方向：</span>
                    {{ item.academicfield }}
                  </div>
                  <div class="swiperlist-intro textover" v-if="item.award">
                    <span class="littletitle">所获奖项：</span>
                    {{ item.award }}
                  </div>
                  <!-- 图书数量： -->
                  <div class="swiperlist-intro textover" v-if="item.totalCount">
                    <span class="littletitle">图书数量：</span>
                    {{ item.totalCount }}
                  </div>
                  <!-- <div class="swiperlist-intro textover"><span v-if="item.bookCount"><span class="littletitle">纸书：</span>{{item.bookCount}}</span><span v-if="item.ebookCount"><span class="littletitle littleleft">电子书：</span>{{item.ebookCount}}</span></div> -->
                </div>
              </div>
              <div class="nodata" v-if="seniorAuthortotal == 0">
                <img src="../../assets/images/ibnoData.png" alt="" />
                <p>暂无内容</p>
              </div>
            </div>
            <div class="swiper-slide">
              <div
                class="swiperlist"
                v-for="(item, index) in seniorAwardList"
                :key="item.ruid"
                v-show="index < 2"
              >
                <div
                  class="swiperlist-left"
                  @click="clickMore('knowledgeaward', item.ruid)"
                >
                  <p><img :src="preview(item.cover)" class="swiperlist-img" /></p>
                </div>
                <div class="swiperlist-right">
                  <div
                    class="award-title swiperlist-name textover"
                    :title="item.title"
                    @click="clickMore('knowledgeaward', item.ruid)"
                    v-html="item.title"
                  ></div>
                  <div
                    class="award-titlecn textover"
                    v-if="item.titleCn"
                    v-html="item.titleCn"
                  ></div>
                  <div class="swiperlist-intro textover" v-if="item.organizer">
                    <span class="littletitle">主办方：</span>
                    {{ item.organizer }}
                  </div>
                  <div class="swiperlist-intro textover" v-if="item.country2">
                    <span class="littletitle">国别：</span>
                    {{ item.country2 }}
                  </div>
                  <div class="swiperlist-intro textover" v-if="item.subcategory">
                    <span class="littletitle">子奖项：</span>
                    {{ item.subcategory }}
                  </div>
                  <div class="swiperlist-intro textover" v-if="item.created">
                    <span class="littletitle">奖项开始时间：</span>
                    {{ item.created }}
                  </div>
                  <div class="swiperlist-intro textover" v-if="item.latest">
                    <span class="littletitle">最新奖项时间：</span>
                    {{ item.latest }}
                  </div>
                  <!-- 图书数量： -->
                  <div class="swiperlist-intro textover" v-if="item.totalcount">
                    <span class="littletitle">图书资源：</span>
                    {{ item.totalcount }}
                  </div>
                  <!-- <div class="swiperlist-intro textover"><span v-if="item.bookCount"><span class="littletitle">纸书：</span>{{item.bookCount}}</span><span v-if="item.ebookCount"><span class="littletitle littleleft">电子书：</span>{{item.ebookCount}}</span></div> -->
                </div>
              </div>
              <div class="nodata" v-if="seniorAwardtotal == 0">
                <img src="../../assets/images/ibnoData.png" alt="" />
                <p>暂无内容</p>
              </div>
            </div>
            <div class="swiper-slide">
              <div
                class="swiperlist"
                v-for="(item, index) in seniorLibraryList"
                :key="item.ruid"
                v-show="index < 2"
              >
                <div
                  class="swiperlist-left"
                  @click="clickMore('knowledgelibray', item.customercode)"
                >
                  <p><img :src="preview(item.listbanner)" class="swiperlist-img" /></p>
                </div>
                <div class="swiperlist-right">
                  <div
                    class="award-title swiperlist-name textover"
                    :title="item.title"
                    @click="clickMore('knowledgelibray', item.customercode)"
                    v-html="item.title"
                  ></div>
                  <div
                    class="award-titlecn textover"
                    v-if="item.titleCn"
                    v-html="item.titleCn"
                  ></div>
                  <div v-if="item.country2" class="swiperlist-intro textover">
                    <span class="littletitle">国别：</span>
                    {{ item.country2 }}
                  </div>
                  <!-- <div v-if="item.province" class="swiperlist-intro textover"><span class="littletitle">地区：</span>{{item.province}}</div> -->
                  <div v-if="item.publishertype" class="swiperlist-intro textover">
                    <span class="littletitle">机构类型：</span>
                    {{ item.publishertype }}
                  </div>
                  <div v-if="item.domain" class="swiperlist-intro textover">
                    <span class="domain">网址：</span>
                    <span class="wwwclick" @click="wwwclick(item.domain)">
                      {{ item.domain }}
                    </span>
                  </div>
                  <div v-if="item.subject" class="swiperlist-intro textover">
                    <span class="littletitle">重点学科：</span>
                    {{ item.subject }}
                  </div>
                  <div class="swiperlist-intro textover">
                    <span v-if="item.totalCount">
                      <span class="littletitle">图书资源：</span>
                      {{ item.totalCount }}
                    </span>
                    <span v-if="item.collectionCount">
                      <span class="littletitle littleleft">数据库：</span>
                      {{ item.collectionCount }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="nodata" v-if="seniorLibrarytotal == 0">
                <img src="../../assets/images/ibnoData.png" alt="" />
                <p>暂无内容</p>
              </div>
            </div>
            <div class="swiper-slide">
              <div
                class="swiperlist"
                v-for="(item, index) in seniorPublisherList"
                :key="item.ruid"
                v-show="index < 2"
              >
                <div
                  class="swiperlist-left"
                  @click="clickMore('knowledgepublisher', item.customercode)"
                >
                  <p><img :src="preview(item.listbanner)" class="swiperlist-img" /></p>
                </div>
                <div class="swiperlist-right">
                  <div
                    class="award-title swiperlist-name textover"
                    :title="item.title"
                    @click="clickMore('knowledgepublisher', item.customercode)"
                  >
                    {{ item.title }}
                  </div>
                  <div class="award-titlecn textover" v-if="item.titleCn">
                    {{ item.titleCn }}
                  </div>
                  <div class="swiperlist-intro textover" v-if="item.country2">
                    <span class="littletitle">国别：</span>
                    {{ item.country2 }}
                  </div>
                  <div class="swiperlist-intro textover" v-if="item.publishertype">
                    <span class="littletitle">出版社类型：</span>
                    {{ item.publishertype }}
                  </div>
                  <div class="swiperlist-intro textover" v-if="item.language">
                    <span class="littletitle">出版语种：</span>
                    {{ item.language }}
                  </div>
                  <div class="swiperlist-intro textover" v-if="item.subject">
                    <span class="littletitle">出版学科：</span>
                    {{ item.subject }}
                  </div>
                  <div class="swiperlist-intro textover" v-if="item.reader">
                    <span class="littletitle">读者群：</span>
                    {{ item.reader }}
                  </div>
                  <div class="swiperlist-intro textover">
                    <span v-if="item.totalCount">
                      <span class="littletitle">图书资源：</span>
                      {{ item.totalCount }}
                    </span>
                    <span v-if="item.collectionCount">
                      <span class="littletitle littleleft">数据库：</span>
                      {{ item.collectionCount }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="nodata" v-if="seniorPublishertotal == 0">
                <img src="../../assets/images/ibnoData.png" alt="" />
                <p>暂无内容</p>
              </div>
            </div>
          </div>
          <div class="swiper-pagination"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import urlSet from '@/utils/common.js'

export default {
  name: 'managerhome',
  components: {},
  data() {
    return {
      obj: {},
      fairList: [],
      messageList: [],
      paperList: [],
      paperEbookList: [],
      ebookList: [],
      seniorEbookCollectionList: [],
      seniorAuthorList: [],
      seniorAwardList: [],
      seniorLibraryList: [],
      seniorPublisherList: [],
      paperimg: true,
      paperebookimg: false,
      ebookimg: false,
      noImg: require('../../assets/images/not.png'),
      blueImg: require('../../assets/images/resource-icon-juxing.png'),
      grayImg: require('../../assets/images/resource-icon-juxing-gray.png'),
      mySwiper: '',
      typeFlag: 1,
      messagetotal: 0,
      papertotal: 0,
      paperEbooktotal: 0,
      ebooktotal: 0,
      seniorAuthortotal: 0,
      seniorEbookCollectiontotal: 0,
      seniorAwardtotal: 0,
      seniorLibrarytotal: 0,
      seniorPublishertotal: 0,
      messageLoading: true,
      booksLoading: true,
      knowledgeLoading: true,
    }
  },
  mounted() {
    document.title = '知源机构服务平台 - 首页'
    this.getList('message')
    this.getList('books')
    this.getList('knowledge')
    this.initSlider()
  },
  methods: {
    handleChangeTab(index) {
      this.mySwiper.slideTo(index - 1)
    },
    getQuery(area) {
      if (area === 'message') {
        return 'fairList,thematiclibList,messageList,informationList'
      } else if (area === 'books') {
        return 'paperList,ebookList,seniorEbookCollectionList'
      } else if (area === 'knowledge') {
        return 'seniorAuthorList,seniorAwardList,seniorLibraryList,seniorPublisherList'
      }
    },
    getList(area) {
      let qs = this.getQuery(area)
      this.$http({
        url: `/api/v1/customer/search/home/home_www?refresharea=${qs}`,
        method: 'GET',
      }).then(res => {
        this.obj = res.returnvalue
        if (area === 'message') {
          // 站内消息
          if (this.messageList) {
            this.messageList = res.returnvalue.messageList
            this.messagetotal = res.returnvalue.messageList.length
          }
          var fairList = []
          if (res.returnvalue.fairList) {
            res.returnvalue.fairList.forEach(item => {
              item.type = 'fairindex'
            })
            if (res.returnvalue.fairList.length > 1) {
              fairList.push(res.returnvalue.fairList[0])
              fairList.push(res.returnvalue.fairList[1])
            } else if (res.returnvalue.fairList.length > 0) {
              fairList.push(res.returnvalue.fairList[0])
            }
          }
          if (res.returnvalue.informationList) {
            res.returnvalue.informationList.forEach(item => {
              item.type = 'informationindex'
            })
            if (res.returnvalue.informationList.length > 1) {
              fairList.push(res.returnvalue.informationList[0])
              fairList.push(res.returnvalue.informationList[1])
            } else if (res.returnvalue.informationList.length > 0) {
              fairList.push(res.returnvalue.informationList[0])
            }
          }
          if (res.returnvalue.thematiclibList) {
            res.returnvalue.thematiclibList.forEach(item => {
              item.type = 'thematiclibindex'
            })
            if (res.returnvalue.thematiclibList.length > 1) {
              fairList.push(res.returnvalue.thematiclibList[0])
              fairList.push(res.returnvalue.thematiclibList[1])
            } else if (res.returnvalue.thematiclibList.length > 0) {
              fairList.push(res.returnvalue.thematiclibList[0])
            }
          }
          this.fairList = fairList
          this.messageLoading = false
        } else if (area === 'books') {
          this.paperList = res.returnvalue.paperList
          if (this.paperList) {
            this.papertotal = res.returnvalue.paperList.length
          }
          this.paperEbookList = res.returnvalue.paperEbookList
          if (this.paperEbookList) {
            this.paperEbooktotal = res.returnvalue.paperEbookList.length
          }
          this.ebookList = res.returnvalue.ebookList
          if (this.ebookList) {
            this.ebooktotal = res.returnvalue.ebookList.length
          }
          this.seniorEbookCollectionList = res.returnvalue.seniorEbookCollectionList
          if (this.seniorEbookCollectionList) {
            this.seniorEbookCollectiontotal =
              res.returnvalue.seniorEbookCollectionList.length
          }
          this.booksLoading = false
        } else if (area === 'knowledge') {
          this.seniorAuthorList = res.returnvalue.seniorAuthorList
          if (this.seniorAuthorList) {
            this.seniorAuthortotal = res.returnvalue.seniorAuthorList.length
          }
          this.seniorAwardList = res.returnvalue.seniorAwardList
          if (this.seniorAwardList) {
            this.seniorAwardtotal = res.returnvalue.seniorAwardList.length
          }
          this.seniorLibraryList = res.returnvalue.seniorLibraryList
          if (this.seniorLibraryList) {
            this.seniorLibrarytotal = res.returnvalue.seniorLibraryList.length
            this.seniorLibraryList.forEach((element, index) => {
              this.seniorLibraryList[index].title = element.title
                .split('<i>')
                .join('')
                .split('</i>')
                .join('')
            })
          }
          this.seniorPublisherList = res.returnvalue.seniorPublisherList
          if (this.seniorPublisherList) {
            this.seniorPublishertotal = res.returnvalue.seniorPublisherList.length
          }
          this.knowledgeLoading = false
        }
      })
    },
    initSlider() {
      setTimeout(() => {
        this.mySwiper = new Swiper('.swiper-container', {
          autoplay: 5000, //可选选项，自动滑动
          pagination: '.swiper-pagination',
          loop: false,
          paginationClickable: true,
          //获取当前展示页面添加选中效果
          onSlideChangeEnd: function(swiper) {
            if (swiper.activeIndex == '1') {
              document
                .getElementById('keyaward')
                .setAttribute('class', 'knowledge-keypoint-word-click')
              document
                .getElementById('keylibrary')
                .setAttribute('class', 'knowledge-keypoint-word')
              document
                .getElementById('keypublisher')
                .setAttribute('class', 'knowledge-keypoint-word')
              document
                .getElementById('keyauthor')
                .setAttribute('class', 'knowledge-keypoint-word')
            } else if (swiper.activeIndex == '2') {
              document
                .getElementById('keylibrary')
                .setAttribute('class', 'knowledge-keypoint-word-click')
              document
                .getElementById('keyaward')
                .setAttribute('class', 'knowledge-keypoint-word')
              document
                .getElementById('keypublisher')
                .setAttribute('class', 'knowledge-keypoint-word')
              document
                .getElementById('keyauthor')
                .setAttribute('class', 'knowledge-keypoint-word')
            } else if (swiper.activeIndex == '3') {
              document
                .getElementById('keypublisher')
                .setAttribute('class', 'knowledge-keypoint-word-click')
              document
                .getElementById('keylibrary')
                .setAttribute('class', 'knowledge-keypoint-word')
              document
                .getElementById('keyaward')
                .setAttribute('class', 'knowledge-keypoint-word')
              document
                .getElementById('keyauthor')
                .setAttribute('class', 'knowledge-keypoint-word')
            } else {
              document
                .getElementById('keyauthor')
                .setAttribute('class', 'knowledge-keypoint-word-click')
              document
                .getElementById('keylibrary')
                .setAttribute('class', 'knowledge-keypoint-word')
              document
                .getElementById('keypublisher')
                .setAttribute('class', 'knowledge-keypoint-word')
              document
                .getElementById('keyaward')
                .setAttribute('class', 'knowledge-keypoint-word')
            }
          },
        })
      }, 500)
    },
    //图片处理
    preview(iconUrl) {
      let url = iconUrl
      if (url != null && url != undefined) {
        if (url.indexOf('http') != -1) {
          return url
        } else {
          url = url.replace(/\//g, '%2F')
          let httpStr = this.$fileapi + url
          return httpStr
        }
      } else {
        return this.noImg
      }
    },
    //网址跳转
    wwwclick(val) {
      if (val.substr(0, 7) == 'http://' || val.substr(0, 8) == 'https://') {
        window.open(val)
      } else {
        window.open('http://' + val)
      }
    },
    //检索

    //详细
    clickMore: function(type, ruid) {
      switch (type) {
        case 'fairindex':
          window.location.href = '/fair/#/?fair=' + ruid
          break
        case 'informationindex':
          // window.location.href="/ibinfordetail?ruid="+ruid
          this.$router.push({
            path: '/ibinfordetail',
            query: { ruid },
          })
          //  window.location.href='/knowledgecenter/#/ibinfordetail?ruid='+ruid
          break
        case 'thematiclibindex':
          this.$router.push({
            path: '/hot/detail',
            query: { ruid },
          })
          // window.location.href="/hot/detail?ruid="+ruid;
          break
        case 'notice':
          this.$router.push({
            path: '/noticdetail',
            query: { ruid },
          })
          // window.location.href='/knowledgecenter/#/noticdetail?ruid='+ruid
          //window.location.href="/noticdetail?ruid="+ruid;
          break
        case 'resource':
          let filters = []
          let obj = {
            logicalop: 'and',
            relationop: 'in',
            valuetype: 'N',
          }
          let filter = JSON.parse(JSON.stringify(obj))
          filter.title = '资源类型'
          filter.fieldname = 100
          filter.valuetype = 'N'
          if (this.typeFlag == 1) {
            filter = {
              title: '资源类型',
              name: '纸书',
              logicalop: 'and',
              fieldname: '',
              relationop: 'group',
              word: '',
              children: [
                {
                  logicalop: 'and',
                  fieldname: '100',
                  relationop: '=',
                  word: '1987051001',
                },
              ],
            }
          } else if (this.typeFlag == 2) {
            filter = {
              title: '资源类型',
              name: '纸+电',
              logicalop: 'and',
              fieldname: '',
              relationop: 'group',
              word: '',
              children: [
                {
                  logicalop: 'and',
                  fieldname: '100',
                  relationop: '=',
                  word: '1987054001',
                },
              ],
            }
          } else {
            filter = {
              title: '资源类型',
              name: '电子书',
              logicalop: 'and',
              fieldname: '',
              relationop: 'group',
              word: '',
              children: [
                {
                  logicalop: 'and',
                  fieldname: '100',
                  relationop: '=',
                  word: '1987052001',
                },
              ],
            }
          }
          filters.push(filter)
          sessionStorage.setItem(
            'searchFilter',
            JSON.stringify({ search: [], left: filters, top: [], date: [] })
          )
          window.open(`${urlSet.baseUrl}/dc/#/BookList`)
          break
        case 'paperList':
          window.open(`${urlSet.baseUrl}/dc/#/BookDetail?id=${ruid}&recommendType=5`)
          break
        case 'paperEbookList':
          window.open(`${urlSet.baseUrl}/dc/#/BookDetail?id=${ruid}&recommendType=5`)
          break
        case 'ebookList':
          window.open(`${urlSet.baseUrl}/dc/#/BookDetail?id=${ruid}&recommendType=5`)
          break
        case 'database':
          window.open(`${urlSet.baseUrl}/dc/#/DataList`)
          break
        case 'databasedetail':
          window.open(`${urlSet.baseUrl}/dc/#/DataDetail?id=${ruid}`)
          break
        case 'knowledge':
          var keyauthorattr = document.getElementById('keyauthor').className
          var keyawardattr = document.getElementById('keyaward').className
          var keylibraryattr = document.getElementById('keylibrary').className
          var keypublisherattr = document.getElementById('keypublisher').className
          if (keyauthorattr.indexOf('knowledge-keypoint-word-click') > -1) {
            this.$router.push({
              path: '/list',
              query: { from: 5 },
            })
            // window.location.href='/knowledgecenter/#/list?from=5'
          }
          if (keyawardattr.indexOf('knowledge-keypoint-word-click') > -1) {
            this.$router.push({
              path: '/list',
              query: { from: 6 },
            })
            // window.location.href='/knowledgecenter/#/list?from=6'
          }
          if (keylibraryattr.indexOf('knowledge-keypoint-word-click') > -1) {
            this.$router.push({
              path: '/list',
              query: { from: 9 },
            })
            // window.location.href='/knowledgecenter/#/list?from=9'
          }
          if (keypublisherattr.indexOf('knowledge-keypoint-word-click') > -1) {
            this.$router.push({
              path: '/list',
              query: { from: 8 },
            })
            // window.location.href='/knowledgecenter/#/list?from=8'
          }
          break
        case 'knowledgeauthor':
          // window.location.href='/knowledgecenter/#/author/detail?ruid='+ruid
          // wz
          this.$router.push({
            path: '/author/detail',
            query: { ruid },
          })
          break
        case 'knowledgeaward':
          this.$router.push({
            path: '/prize/detail',
            query: { ruid },
          })
          // window.location.href='/knowledgecenter/#/prize/detail?ruid='+ruid
          break
        case 'knowledgelibray':
          const url = this.$router.resolve({
            path: '/librarydetail',
            query: {
              customer: ruid,
            },
          })
          window.open(url.href)
          break
        case 'knowledgepublisher':
          const url2 = this.$router.resolve({
            path: '/publisherdetail',
            query: {
              customer: ruid,
            },
          })
          window.open(url2.href)
          break
      }
    },
    //图书切换
    chagebook(type) {
      this.typeFlag = type
      if (type == 1) {
        this.paperimg = true
        this.paperebookimg = false
        this.ebookimg = false
        document
          .getElementById('paper')
          .setAttribute('class', 'resource-type-span resource-type-span-blue')
        // document.getElementById("paperebook").setAttribute("class","resource-type-span resource-type-span-gray");
        document
          .getElementById('ebook')
          .setAttribute('class', 'resource-type-span resource-type-span-gray')
        document.getElementById('paperList').style.display = 'block'
        document.getElementById('paperEbookList').style.display = 'none'
        document.getElementById('ebookList').style.display = 'none'
      } else if (type == 2) {
        //纸+电
        this.paperimg = false
        this.paperebookimg = true
        this.ebookimg = false
        document
          .getElementById('paper')
          .setAttribute('class', 'resource-type-span resource-type-span-gray')
        // document.getElementById("paperebook").setAttribute("class","resource-type-span resource-type-span-blue");
        document
          .getElementById('ebook')
          .setAttribute('class', 'resource-type-span resource-type-span-gray')
        document.getElementById('paperList').style.display = 'none'
        document.getElementById('paperEbookList').style.display = 'block'
        document.getElementById('ebookList').style.display = 'none'
      } else if (type == 3) {
        //电子书
        this.paperimg = false
        this.paperebookimg = false
        this.ebookimg = true
        document
          .getElementById('paper')
          .setAttribute('class', 'resource-type-span resource-type-span-gray')
        // document.getElementById("paperebook").setAttribute("class","resource-type-span resource-type-span-gray");
        document
          .getElementById('ebook')
          .setAttribute('class', 'resource-type-span resource-type-span-blue')
        document.getElementById('paperList').style.display = 'none'
        document.getElementById('paperEbookList').style.display = 'none'
        document.getElementById('ebookList').style.display = 'block'
      }
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.container .footer {
  display: none;
}
.managerhome {
  .el-carousel__item.el-carousel__item--card.is-in-stage {
    text-align: center;
  }
  .mid {
    width: 100%;
    opacity: 1;
    background: url(../../assets/images/midbg.png);
    padding-bottom: 50px;
  }
  .mid-one {
    margin-top: -30px;
    height: 376px;
  }
  .pagetext {
    position: absolute;
    margin-left: 700px;
    margin-top: -50px;
  }
  .up-left {
    width: 790px;
    height: 376px;
    background: #ffffff;
    position: absolute;
    padding-top: 20px;
    /*左右箭头的样式*/
    /deep/ .el-carousel__arrow:hover {
      background-color: #2a86fd;
    }
    /deep/ .el-carousel__arrow {
      top: 42%;
    }
    /deep/ .el-carousel__indicators {
      bottom: 20px;
      right: 0px;
      left: auto;
      transform: translateX(0%);
      .el-carousel__indicator {
        border-radius: 0;
        width: 14px;
        height: 14px;
        background: #bbbbbb;
        opacity: 1;
        padding: 0px;
        margin: 5px;
      }
      .is-active {
        background: #2a86fd !important;
      }
      .el-carousel__button {
        width: 0px;
      }
    }
    .oneimg {
      width: 730px;
      height: 300px;
      text-align: center;
      vertical-align: middle;
      cursor: pointer;
      display: -webkit-box; //（Chrome 4+, Safari 3.1, iOS Safari 3.2+）
      display: -moz-box; //（Firefox 17-）
      display: -webkit-flex; //（Chrome 21+, Safari 6.1+, iOS Safari 7+, Opera 15/16）
      display: -moz-flex; //（Firefox 18+ ）
      display: flex; //（Chrome 29+, Firefox 22+, IE 11+, Opera 12.1/17/18, Android 4.4+
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      -webkit-box-pack: center;
      -ms-flex-pack: center;
      justify-content: center;
      overflow: hidden;
    }
  }
  .up-right {
    width: 400px;
    height: 376px;
    background: #ffffff;
    position: absolute;
    margin-left: 800px;
    .notic-title-img {
      padding: 20px 30px;
      border-bottom: 1px solid #eee;
    }
    .notic-info {
      margin: 15px 30px;
      font-size: 16px;
      line-height: 24px;
      border-bottom: 1px dotted #e6e6e6;
      padding-bottom: 10px;
      .notic-title {
        font-weight: 700;
        color: #333333;
        cursor: pointer;
        max-width: 340px;
        height: 48px;
      }
      .notic-time {
        font-weight: 400;
        color: #999999;
      }
    }
  }
}
.mid-two {
  margin-top: 50px;
  .resource-body {
    margin-top: 30px;
    height: 410px;
    background: #ffffff;
    border-radius: 2px;
    padding: 0px 20px;
    .resource-type {
      text-align: center;
    }
    .resource-type-span {
      display: inline-block;
      height: 40px;
      opacity: 1;
      font-size: 18px;
      font-family: Microsoft YaHei Regular, Microsoft YaHei Regular-Regular;
      font-weight: 400;
      text-align: left;
      line-height: 40px;
      margin: 15px;
      cursor: pointer;
      .resourceimg {
        padding: 3px;
      }
    }
    .resource-type-span-blue {
      color: #2a86fd;
    }
    .resource-type-span-gray {
      color: #666666;
    }
  }
  .resource-object {
    padding-left: 16px;
    padding-right: 16px;
    float: left;
    cursor: pointer;
    .img {
      position: relative;
      height: 198px;
      width: 198px;
      line-height: 198px;
      border: 1px solid #e1e1e1;
      text-align: center;
      margin-right: 0px;
      font-size: 207px;
      vertical-align: middle;
      cursor: pointer;
    }
    .resource-object-img {
      display: inline-block;
      max-width: 100%;
      max-height: 100%;
    }
    .resource-title {
      width: 200px;
      max-height: 45px;
      font-size: 16px;
      line-height: 24px;
      font-weight: 700;
      color: #333333;
      text-overflow: ellipsis;
      display: -webkit-box;
      margin: 15px 0px 10px 0px;
    }
    .resource-titlecn {
      width: 200px;
      height: 45px;
      opacity: 1;
      font-size: 16px;
      font-weight: 400;
      color: #666666;
      text-overflow: ellipsis;
      display: -webkit-box;
      line-height: 24px;
    }
  }
  .resource-object-hide {
    display: none;
  }
}
.mid-three {
  width: 100%;
  height: 317px;
  background: url(../../assets/images/threebg.png);
  background-repeat: no-repeat;
  background-size: 100% 100%;
  -moz-background-size: 100% 100%;
  .database-title-img {
    padding-top: 50px;
  }
  .database-more {
    color: #fff;
  }
  .database-list {
    margin-top: 30px;
    .database-object {
      float: left;
      display: flex;
      width: 600px;
      .database-logo-div {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 300px;
        height: 150px;
        background-color: #fff;
        cursor: pointer;
        .database-logo {
          max-width: 300px;
          max-height: 150px;
        }
      }
      .database-info {
        display: inline-block;
        max-width: 276px;
        margin-left: 20px;
        .database-title {
          font-size: 16px;
          font-weight: 700;
          color: #ffffff;
          margin-bottom: 10px;
          height: 18px;
          cursor: pointer;
        }
        .database-intro {
          font-size: 16px;
          color: #ffffff;
          line-height: 24px;
          height: 24px;
        }
      }
    }
  }
}
.mid-four {
  margin-top: 50px;
  margin-bottom: 38px;
  .knowledge-bar-img {
    width: 315px;
  }
  .swiper-container {
    width: 1140px;
    height: 270px;
    word-break: break-all;
  }
  .swiperlist:nth-child(1) {
    border-right: 1px solid #eeeeee;
    padding-right: 59px;
  }
  .swiperlist:nth-child(2) {
    margin-left: 59px;
  }
  .swiperlist {
    float: left;
    width: 540px;
    .swiperlist-left {
      float: left;
      width: 200px;
      height: 200px;
      border: 1px solid #eeeeee;
      cursor: pointer;
      display: flex;
      -webkit-box-align: center;
      -webkit-box-pack: center;
      -ms-flex-align: center;
      align-items: center;
      -ms-flex-pack: center;
      justify-content: center;
      .swiperlist-img {
        max-width: 196px;
        max-height: 196px;
        background: #ffffff;
        cursor: pointer;
      }
    }
    .swiperlist-right {
      display: inline-block;
      max-width: 260px;
      margin-left: 20px;
      .swiperlist-name {
        font-size: 18px;
        font-weight: 700;
        color: #333;
        margin-bottom: 5px;
        height: 24px;
        cursor: pointer;
      }
      .award-titlecn {
        height: 24px;
        font-size: 18px;
        font-weight: 400;
        color: #666666;
        margin-bottom: 5px;
      }
      .swiperlist-intro {
        font-size: 16px;
        color: #666;
        line-height: 24px;
        height: 24px;
      }
      .littletitle {
        color: #333;
      }
    }
  }
  .keypoint-list {
    margin-top: 30px;
    overflow: hidden;
    .keypoint {
      width: 300px;
      height: 90px;
      float: left;
      text-align: center;
      cursor: pointer;
      .knowledge-keypoint-word {
        width: 300px;
        font-size: 18px;
        color: #333333;
        line-height: 58px;
      }
      .knowledge-keypoint-word-click {
        width: 300px;
        font-size: 18px;
        line-height: 58px;
        border-bottom: 2px solid #2a86fd;
        color: #2a86fd;
      }
    }
  }
}
.bookfair-name {
  text-align: center;
  width: 600px;
  max-width: 600px;
  display: inline-block;
  opacity: 1;
  font-size: 16px;
  font-family: Microsoft YaHei Bold, Microsoft YaHei Bold-Bold;
  font-weight: 700;
  color: #333333;
  line-height: 48px;
  background-color: white;
  cursor: pointer;
}

.bookfair-index {
  width: 24px;
  height: 14px;
  opacity: 1;
  font-size: 16px;
  font-family: Microsoft YaHei Regular, Microsoft YaHei Regular-Regular;
  font-weight: 400;
  color: #666666;
  line-height: 48px;
}

.bookfair-index-current {
  color: #2a86fd;
}
//title标题
.stitle-img-div {
  text-align: center;
}
.stitle-img {
  width: 245px;
  height: 38px;
  margin: 0px auto;
}
.stitle-more {
  margin-left: auto;
  float: right;
  line-height: 40px;
  color: #999;
}
.textover {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  -webkit-line-clamp: 1;
  word-break: break-all;
}
.swipertab {
  width: 1200px;
  height: 323px;
  background: #ffffff;
  box-shadow: 0px 0px 10px 1px #ededed;
  padding: 30px;
}
.stitle-more {
  cursor: pointer;
}
.littleleft {
  margin-left: 10px;
}
.wwwclick {
  color: #2a86fd;
  text-decoration: underline;
  cursor: pointer;
}
.nodata {
  width: 100px;
  margin: 0px auto;
  margin-top: 30px;
  p {
    text-align: center;
    margin-top: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/managerHome/home.vue